"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dateFns = require("date-fns");

var _radio = _interopRequireDefault(require("britive-design-system/core/components/radio"));

var _checkbox = _interopRequireDefault(require("britive-design-system/core/components/checkbox"));

var _textarea = _interopRequireDefault(require("britive-design-system/core/components/textarea"));

var _typography = _interopRequireDefault(require("britive-design-system/core/components/typography"));

var _datePickerWithValidation = _interopRequireDefault(require("../../../../date-picker-with-validation"));

var _timezoneSelector = _interopRequireDefault(require("../../../../timezone-selector"));

var _daySelector = _interopRequireDefault(require("../../../../day-selector"));

var _commonConstants = require("../../../../../utils/common-constants");

var _commonUtils = require("../../../../../utils/common-utils");

var _constants = require("./constants");

var _constant = require("../../../../day-selector/constant");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n.policy-generic-conditions-tab-main-container {\n  flex-grow: 1;\n  padding-top: 3rem;\n  padding-left: 3.5rem;\n  padding-bottom: 3rem;\n  padding-right: 2rem;\n  overflow: auto; }\n  .policy-generic-conditions-tab-main-container::-webkit-scrollbar {\n    width: 0.5rem;\n    height: 0.5rem; }\n  .policy-generic-conditions-tab-main-container::-webkit-scrollbar-track {\n    border-radius: 0.5rem;\n    margin-top: 0.125rem; }\n  .policy-generic-conditions-tab-main-container::-webkit-scrollbar-thumb {\n    border-radius: 0.5rem;\n    background-color: #c6c6c6; }\n  .policy-generic-conditions-tab-main-container::-webkit-scrollbar-thumb:hover {\n    background-color: #6f6f6f; }\n  .policy-generic-conditions-tab-main-container .sm-form-name-loader-wrapper {\n    display: flex;\n    align-items: center; }\n    .policy-generic-conditions-tab-main-container .sm-form-name-loader-wrapper .sm-form-name-check-loader {\n      margin-top: 1.25rem;\n      margin-left: 0.625rem; }\n  .policy-generic-conditions-tab-main-container .sm-add-policy-field-wrapper {\n    margin-bottom: 2rem; }\n  .policy-generic-conditions-tab-main-container .sm-add-policy-field-value-wrapper {\n    margin-top: 0.5rem; }\n  .policy-generic-conditions-tab-main-container .sm-value-wrapper {\n    margin-top: 0.625rem; }\n  .policy-generic-conditions-tab-main-container .sm-fields-group-wrapper {\n    display: flex;\n    justify-content: space-between;\n    width: 512px; }\n  .policy-generic-conditions-tab-main-container .sm-horizontal-field {\n    display: flex;\n    justify-content: space-between;\n    align-items: center; }\n    .policy-generic-conditions-tab-main-container .sm-horizontal-field .sec-mgr-date-picker-wrapper {\n      margin-left: 0.5rem;\n      margin-top: 0; }\n";
  var fileName = "compone_AddGenericConditions";
  var element = document.querySelector("style[data-sass-component='compone_AddGenericConditions']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var GenericConditions = function GenericConditions(_ref) {
  var validationHook = _ref.validationHook,
      translatedStrings = _ref.translatedStrings,
      isDateTimeData = _ref.isDateTimeData,
      isIPAddressData = _ref.isIPAddressData,
      consumer = _ref.consumer;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.stepperMainContainer
  }, consumer !== _commonConstants.papServiceConsumer && /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyFieldWrapper
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, " ", translatedStrings.accessType, " "), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyFieldValueWrapper
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, " ", validationHook.values.allowDeny, " "))), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyFieldWrapper
  }, /*#__PURE__*/_react.default.createElement(_radio.default, {
    defaultValue: "".concat(validationHook.values.isIpAddress),
    direction: "vertical",
    label: translatedStrings.conditionsIpAddr,
    name: "ipAddr",
    options: isIPAddressData,
    onChange: function onChange(e) {
      var values = e.target.value === 'true';
      validationHook.handleChange(validationHook.names.isIpAddress, values);

      if (!values) {
        validationHook.handleChange(validationHook.names.ipAddress, '');
      }
    }
  })), validationHook.values.isIpAddress && /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyFieldWrapper
  }, /*#__PURE__*/_react.default.createElement(_textarea.default, {
    height: "72px",
    width: "512px",
    label: translatedStrings.ipLabel,
    helperText: translatedStrings.ipLabelHelperText,
    subLabel: translatedStrings.ipSubLabel,
    value: validationHook.values.ipAddress,
    onChange: function onChange(e) {
      return validationHook.handleChange(validationHook.names.ipAddress, e.target.value);
    },
    onBlur: function onBlur() {
      return validationHook.handleBlur(validationHook.names.ipAddress);
    },
    error: validationHook.touched.ipAddress && Boolean(validationHook.errors.ipAddress),
    errorMsg: validationHook.errors.ipAddress
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyFieldWrapper
  }, /*#__PURE__*/_react.default.createElement(_radio.default, {
    defaultValue: "".concat(validationHook.values.isDateTime),
    direction: "vertical",
    label: translatedStrings.conditionsDateTime,
    name: "dateTime",
    options: isDateTimeData,
    onChange: function onChange(e) {
      var values = e.target.value === 'true';
      validationHook.handleChange(validationHook.names.isDateTime, values);

      if (!values) {
        validationHook.handleChange(validationHook.names.dateSchedule, false);
        validationHook.handleChange(validationHook.names.daysSchedule, false);
      }
    }
  })), validationHook.values.isDateTime && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyFieldValueWrapper
  }, /*#__PURE__*/_react.default.createElement(_checkbox.default, {
    name: "dateSchedule",
    label: translatedStrings.specifyDateTime,
    checked: validationHook.values.dateSchedule,
    onChange: function onChange(e) {
      var value = e.target.checked;
      validationHook.handleChange(validationHook.names.dateSchedule, value);
      validationHook.handleBlur(validationHook.names.isDateTime);

      if (!value) {
        validationHook.handleChange(validationHook.names.startDate, null);
        validationHook.handleChange(validationHook.names.endDate, null);

        if (!validationHook.values.daysSchedule) {
          validationHook.handleChange(validationHook.names.timezone, null);
        }
      }
    }
  })), validationHook.values.dateSchedule && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyFieldWrapper
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyFieldWrapper
  }, validationHook.values.startDate && validationHook.values.endDate && validationHook.values.timezone && /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, "From ".concat((0, _moment.default)(validationHook.values.startDate).format("MM/DD/yyyy hh:mm A"), " \n                      ").concat(validationHook.values.timezone.utc, " to \n                      ").concat((0, _moment.default)(validationHook.values.endDate).format("MM/DD/yyyy hh:mm A"), " \n                      ").concat(validationHook.values.timezone.utc))), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyFieldWrapper
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyFieldValueWrapper
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, translatedStrings.startDate)), /*#__PURE__*/_react.default.createElement(_datePickerWithValidation.default, {
    width: _constants.datePickerWidth,
    height: _constants.datePickerHeight,
    dateFormat: _constants.dateFormat,
    selected: validationHook.values.startDate ? new Date(validationHook.values.startDate) : null,
    showTimeSelect: true,
    onChange: function onChange(date) {
      validationHook.handleChange(validationHook.names.startDate, new Date(date));

      if (validationHook.touched.startDate) {
        validationHook.handleBlur(validationHook.names.startDate);
      }
    },
    required: true,
    onSelect: function onSelect(date) {
      validationHook.handleBlur(validationHook.names.startDate);
      validationHook.handleChange(validationHook.names.startDate, new Date(date) > new Date() ? new Date(date) : new Date((0, _dateFns.setMinutes)(new Date(), new Date().getMinutes() > 30 ? 60 : 30)));
    },
    onBlur: function onBlur() {
      validationHook.handleBlur(validationHook.names.startDate);
    },
    error: validationHook.touched.startDate && Boolean(validationHook.errors.startDate),
    errorMessage: validationHook.errors.startDate ? validationHook.errors.startDate : '',
    minDate: new Date(),
    showDisabledMonthNavigation: true
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyFieldWrapper
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.valueWrapper
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, " ", translatedStrings.endDate, " ")), /*#__PURE__*/_react.default.createElement(_datePickerWithValidation.default, {
    width: _constants.datePickerWidth,
    height: _constants.datePickerHeight,
    dateFormat: _constants.dateFormat,
    selected: validationHook.values.endDate ? new Date(validationHook.values.endDate) : null,
    showTimeSelect: true,
    onChange: function onChange(date) {
      validationHook.handleChange(validationHook.names.endDate, new Date(date));

      if (validationHook.touched.endDate) {
        validationHook.handleBlur(validationHook.names.endDate);
      }
    },
    required: true,
    onSelect: function onSelect(date) {
      validationHook.handleBlur(validationHook.names.endDate);
      var endDate = new Date(date);
      var startDate = new Date(validationHook.values.startDate);
      validationHook.handleChange(validationHook.names.endDate, endDate > startDate ? endDate : new Date((0, _dateFns.setMinutes)(startDate, 30)));
    },
    onBlur: function onBlur() {
      validationHook.handleBlur(validationHook.names.endDate);
    },
    error: validationHook.touched.endDate && Boolean(validationHook.errors.endDate),
    errorMessage: validationHook.errors.endDate ? validationHook.errors.endDate : '',
    minDate: new Date(validationHook.values.startDate),
    showDisabledMonthNavigation: true
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyFieldWrapper
  }, /*#__PURE__*/_react.default.createElement(_timezoneSelector.default, {
    label: translatedStrings.timezone,
    placeholder: translatedStrings.timezone,
    width: _constants.datePickerWidth,
    value: validationHook.values.timezone,
    onChange: function onChange(_, value) {
      validationHook.handleChange(validationHook.names.timezone, value);
    },
    onBlur: function onBlur() {
      return validationHook.handleBlur(validationHook.names.timezone);
    },
    errorMessage: validationHook.touched.timezone && Boolean(validationHook.errors.timezone) ? validationHook.errors.timezone : '',
    error: validationHook.values.dateSchedule && validationHook.touched.timezone && Boolean(validationHook.errors.timezone)
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyFieldValueWrapper
  }, /*#__PURE__*/_react.default.createElement(_checkbox.default, {
    name: "daysSchedule",
    label: translatedStrings.setTime,
    checked: validationHook.values.daysSchedule,
    onChange: function onChange(e) {
      var value = e.target.checked;
      validationHook.handleChange(validationHook.names.daysSchedule, value);
      validationHook.handleBlur(validationHook.names.isDateTime);

      if (!value) {
        validationHook.handleChange(validationHook.names.startTime, null);
        validationHook.handleChange(validationHook.names.endTime, null);

        if (!validationHook.values.dateSchedule) {
          validationHook.handleChange(validationHook.names.timezone, null);
        }
      } else {
        validationHook.handleChange(validationHook.names.selectedDays, _constant.days);
      }
    }
  })), validationHook.values.daysSchedule && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyFieldWrapper
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyFieldWrapper
  }, validationHook.values.startTime && validationHook.values.endTime && validationHook.values.timezone && validationHook.values.selectedDays.length > 0 && /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, "Available from \n                      ".concat((0, _moment.default)(validationHook.values.startTime).format("hh:mm A"), " \n                      ").concat(validationHook.values.timezone.utc, " to \n                      ").concat((0, _moment.default)(validationHook.values.endTime).format("hh:mm A"), " \n                      ").concat(validationHook.values.timezone.utc, " on every \n                      ").concat((0, _commonUtils.getDaysString)(validationHook.values.selectedDays)))), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyFieldWrapper
  }, /*#__PURE__*/_react.default.createElement(_daySelector.default, {
    onChange: function onChange(selectedDays) {
      validationHook.handleChange(validationHook.names.selectedDays, selectedDays);
    },
    values: validationHook.values.selectedDays,
    errorMessage: validationHook.errors.selectedDays
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyFieldWrapper
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.fieldsGroupWrapper
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.horizontalField
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, translatedStrings.startTime), /*#__PURE__*/_react.default.createElement(_datePickerWithValidation.default, {
    width: _constants.timePickerWidth,
    height: _constants.datePickerHeight,
    selected: validationHook.values.startTime ? new Date(validationHook.values.startTime) : null,
    onChange: function onChange(date) {
      validationHook.handleChange(validationHook.names.startTime, date ? new Date(date) : null);
      validationHook.handleBlur(validationHook.names.startTime);
    },
    onBlur: function onBlur() {
      validationHook.handleBlur(validationHook.names.startTime);
    },
    showTimeSelect: true,
    showTimeSelectOnly: true,
    timeCaption: "Time",
    dateFormat: _constants.timeFormat,
    excludeTimes: validationHook.values.endTime ? [new Date(validationHook.values.endTime)] : []
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.horizontalField
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, " ", translatedStrings.endTime, " "), /*#__PURE__*/_react.default.createElement(_datePickerWithValidation.default, {
    width: _constants.timePickerWidth,
    height: _constants.datePickerHeight,
    selected: validationHook.values.endTime ? new Date(validationHook.values.endTime) : null,
    onChange: function onChange(date) {
      validationHook.handleChange(validationHook.names.endTime, date ? new Date(date) : null);
      validationHook.handleBlur(validationHook.names.endTime);
    },
    onBlur: function onBlur() {
      validationHook.handleBlur(validationHook.names.endTime);
    },
    showTimeSelect: true,
    showTimeSelectOnly: true,
    timeCaption: "Time",
    dateFormat: _constants.timeFormat,
    excludeTimes: validationHook.values.startTime ? [new Date(validationHook.values.startTime)] : []
  }))), validationHook.touched.startTime && validationHook.touched.endTime && validationHook.errors.startTime ? /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.errorLabel
  }, validationHook.errors.startTime) : null), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyFieldWrapper
  }, /*#__PURE__*/_react.default.createElement(_timezoneSelector.default, {
    readOnly: validationHook.values.dateSchedule,
    label: translatedStrings.timezone,
    placeholder: translatedStrings.timezone,
    width: _constants.datePickerWidth,
    value: validationHook.values.timezone,
    onChange: function onChange(_, value) {
      validationHook.handleChange(validationHook.names.timezone, value);
    },
    onBlur: function onBlur() {
      return validationHook.handleBlur(validationHook.names.timezone);
    },
    errorMessage: validationHook.touched.timezone && Boolean(validationHook.errors.timezone) ? validationHook.errors.timezone : '',
    error: !validationHook.values.dateSchedule && validationHook.touched.timezone && Boolean(validationHook.errors.timezone)
  }))), validationHook.errors.isDateTime && validationHook.touched.isDateTime ? /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.errorLabel
  }, validationHook.errors.isDateTime) : null));
};

GenericConditions.propTypes = {
  validationHook: _propTypes.default.object,
  translatedStrings: _propTypes.default.object,
  isDateTimeData: _propTypes.default.array,
  isIPAddressData: _propTypes.default.array,
  consumer: _propTypes.default.string
};
var _default = GenericConditions;
exports.default = _default;